import assetPath from '/opt/actions-runner/_work/crate/crate/packages/login/layout/src/background-layout/images/background.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')